import { FormHelperText, Grid, InputLabel, Paper, Tooltip, Typography } from '@material-ui/core';
import { useContext } from 'react';
import { EditInapectionContaxt } from './editInspectionProviderImports';
import { InputText } from '../../../../../../Core/Controls';
import BorderColorIcon from '@material-ui/icons/BorderColor';
import SignaturePad from 'react-signature-canvas';
import moment from 'moment';
import DeleteIcon from '@material-ui/icons/Delete';

export const EditSInspectionSignOFF = ({ classes }) => {
    const { state, portalSettings, handleInput, useDefaultSig, clear, GetTechnicianSign, signCanvas, flags, displayName } = useContext(EditInapectionContaxt);
    let ManagerDeclaration = portalSettings?.portalSettingSignOffManagerDeclaration?.replace('{eventname}', flags.scheduleEventName);
    let OnHireDeclaration = portalSettings?.portalSettingCustomerOnHireDeclaration?.replace('{eventname}', flags.scheduleEventName);
    let OffHireDeclaration = portalSettings?.portalSettingCustomerOffHireDeclaration?.replace('{eventname}', flags.scheduleEventName);
    return (
        <>
            <Grid container item xs={12}>
                <Paper className={classes.paper}>
                    {flags.displayCustomerDeclaration === 0 ? (
                        <Grid item xs={12}>
                            <Grid container xs={12}>
                                <h3 className={classes.headings}>Sign Off</h3>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} className="mandatory-fields">
                                    <div
                                        className={classes.headings}
                                        style={{ marginTop: -30 }}
                                        dangerouslySetInnerHTML={{
                                            __html: ManagerDeclaration
                                        }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center', minHeight: 28, marginBottom: 4 }}>
                                        <InputLabel shrink style={{ margin: 0 }}>
                                            Comment
                                        </InputLabel>
                                    </div>
                                    {state.vehicleInspectionStatusID === 2 ? (
                                        <div
                                            style={{
                                                height: 200,
                                                borderRadius: 4,
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                boxSizing: 'border-box',
                                                padding: 10,
                                                overflow: 'auto'
                                            }}
                                        >
                                            <Typography variant="body1">{state.vehicleInspectionSignedOffComment}</Typography>
                                        </div>
                                    ) : (
                                        <InputText
                                            multiline
                                            rows={8}
                                            placeholder="Comment"
                                            name="vehicleInspectionSignedOffComment"
                                            value={state.vehicleInspectionSignedOffComment}
                                            onChange={handleInput}
                                            disabled={state.signOffsignature}
                                            fullWidth
                                            InputProps={{
                                                style: {
                                                    height: 200,
                                                    alignItems: 'flex-start'
                                                }
                                            }}
                                            inputProps={{
                                                style: {
                                                    height: '100%',
                                                    boxSizing: 'border-box'
                                                }
                                            }}
                                        />
                                    )}
                                    <FormHelperText error>{state.errors?.vehicleInspectionSignedOffComment}</FormHelperText>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 28, marginBottom: 4 }}>
                                        <InputLabel shrink error style={{ margin: 0, display: 'inline-flex', alignItems: 'center' }}>
                                            Signature
                                            {!state.hideSignOff && state.signAvailable && state.vehicleInspectionStatusID !== 2 ? (
                                                <Tooltip title="Use default signature">
                                                    <BorderColorIcon onClick={useDefaultSig} style={{ cursor: 'pointer', marginLeft: 6, fontSize: 18 }} />
                                                </Tooltip>
                                            ) : null}
                                        </InputLabel>
                                        {state.showbtn ? (
                                            <Tooltip title="Clear Signature">
                                                <DeleteIcon
                                                    onClick={clear}
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: 20,
                                                        color: 'rgba(0, 0, 0, 0.54)'
                                                    }}
                                                />
                                            </Tooltip>
                                        ) : null}
                                    </div>

                                    {state.signOffsignature ? (
                                        <div
                                            className="sigContainer"
                                            style={{
                                                height: 200,
                                                borderRadius: 4,
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                boxSizing: 'border-box',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                        >
                                            <img
                                                src={state.signOffsignature}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain',
                                                    display: 'block'
                                                }}
                                                alt="my signature"
                                            />
                                            {state.vehicleInspectionStatusID === 4 ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        background: 'rgba(255, 255, 255, 0.8)',
                                                        padding: '2px 4px',
                                                        borderRadius: 2
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY')}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <div
                                            className="sigContainer"
                                            style={{
                                                height: 200,
                                                borderRadius: 4,
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                boxSizing: 'border-box',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                        >
                                            <SignaturePad
                                                ref={signCanvas}
                                                canvasProps={{ className: 'sigPad' }}
                                                onEnd={() => {
                                                    GetTechnicianSign();
                                                }}
                                            />
                                            {state.vehicleInspectionStatusID === 4 ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        background: 'rgba(255, 255, 255, 0.8)',
                                                        padding: '2px 4px',
                                                        borderRadius: 2
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY')}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                    <FormHelperText error>{state.errors?.vehicleInspectionSignedOffSignature}</FormHelperText>
                                </Grid>
                            </Grid>
                            <Grid container xs={12}>
                                <h5 className={classes.headings}>&nbsp;</h5>
                            </Grid>
                        </Grid>
                    ) : (
                        <Grid item xs={12}>
                            <Grid container xs={12}>
                                <h3 className={classes.headings}>Sign Off</h3>
                            </Grid>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {flags.displayCustomerDeclaration === 1 && (
                                        // <h3 className={classes.headings}>
                                        <div style={{ marginTop: -20 }} className={classes.headings} dangerouslySetInnerHTML={{ __html: OnHireDeclaration }} />
                                        // </h3>
                                    )}
                                    {flags.displayCustomerDeclaration === 2 && (
                                        // <h3 className={classes.headings}>{portalSettings.portalSettingCustomerOffHireDeclaration}</h3>
                                        <div style={{ marginTop: -20 }} className={classes.headings} dangerouslySetInnerHTML={{ __html: OffHireDeclaration }} />
                                    )}
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div style={{ display: 'flex', alignItems: 'center', minHeight: 28, marginBottom: 4 }}>
                                        <InputLabel shrink style={{ margin: 0 }}>
                                            Comment
                                        </InputLabel>
                                    </div>
                                    <InputText
                                        multiline
                                        rows={5}
                                        placeholder="Comment"
                                        name="vehicleInspectionSignedOffComment"
                                        value={state.vehicleInspectionSignedOffComment}
                                        onChange={handleInput}
                                        fullWidth
                                        disabled={state.signOffsignature}
                                        InputProps={{
                                            style: {
                                                height: 126,
                                                alignItems: 'flex-start'
                                            }
                                        }}
                                        inputProps={{
                                            style: {
                                                height: '100%',
                                                boxSizing: 'border-box'
                                            }
                                        }}
                                    />
                                    <FormHelperText error>{state.errors?.vehicleInspectionSignedOffComment}</FormHelperText>

                                    <Grid container spacing={2} style={{ marginTop: 10 }}>
                                        <Grid item xs={6}>
                                            <div style={{ minHeight: 20, marginBottom: 4 }}>
                                                <InputLabel shrink style={{ margin: 0 }}>
                                                    {/* Check carried out by */}
                                                </InputLabel>
                                            </div>
                                            <div
                                                style={{
                                                    height: 40,
                                                    borderRadius: 4,
                                                    border: '1px solid rgba(0, 0, 0, 0.23)',
                                                    boxSizing: 'border-box',
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    background: '#f9f9f9',
                                                    padding: '2px 8px'
                                                }}
                                            >
                                                <Typography variant="body2" style={{ fontWeight: 500, lineHeight: 1.2, fontSize: 13 }}>
                                                    {displayName}
                                                </Typography>
                                                <Typography variant="caption" style={{ color: 'rgba(0, 0, 0, 0.6)', lineHeight: 1.2, fontSize: 11 }}>
                                                    {moment(state.vehicleInspectionInspectorSignOffDate).format('DD/MM/YYYY')}
                                                </Typography>
                                            </div>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <div style={{ minHeight: 20, marginBottom: 4 }}>
                                                <InputLabel shrink error style={{ margin: 0 }}>
                                                    Customer Name
                                                </InputLabel>
                                            </div>
                                            <InputText
                                                placeholder="Customer Name"
                                                name="vehicleInspectionSignedOffName"
                                                onChange={handleInput}
                                                value={state.vehicleInspectionSignedOffName}
                                                disabled={state.signOffsignature}
                                                fullWidth
                                                InputProps={{
                                                    style: {
                                                        height: 40
                                                    }
                                                }}
                                            />
                                            <FormHelperText error>{state.errors?.vehicleInspectionSignedOffName}</FormHelperText>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minHeight: 28, marginBottom: 4 }}>
                                        <InputLabel shrink error style={{ margin: 0, display: 'inline-flex', alignItems: 'center' }}>
                                            Signature
                                            {!state.hideSignOff && state.signAvailable && state.vehicleInspectionStatusID !== 2 ? (
                                                <Tooltip title="Use default signature">
                                                    <BorderColorIcon onClick={useDefaultSig} style={{ cursor: 'pointer', marginLeft: 6, fontSize: 18 }} />
                                                </Tooltip>
                                            ) : null}
                                        </InputLabel>
                                        {state.showbtn ? (
                                            <Tooltip title="Clear Signature">
                                                <DeleteIcon
                                                    onClick={clear}
                                                    style={{
                                                        cursor: 'pointer',
                                                        fontSize: 20,
                                                        color: 'rgba(0, 0, 0, 0.54)'
                                                    }}
                                                />
                                            </Tooltip>
                                        ) : null}
                                    </div>

                                    {state.signOffsignature ? (
                                        <div
                                            className="sigContainer"
                                            style={{
                                                height: 200,
                                                borderRadius: 4,
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                boxSizing: 'border-box',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                        >
                                            <img
                                                src={state.signOffsignature}
                                                style={{
                                                    maxWidth: '100%',
                                                    maxHeight: '100%',
                                                    objectFit: 'contain',
                                                    display: 'block'
                                                }}
                                                alt="my signature"
                                            />
                                            {state.vehicleInspectionStatusID === 4 ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        background: 'rgba(255, 255, 255, 0.8)',
                                                        padding: '2px 4px',
                                                        borderRadius: 2
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY HH:mm')}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                        </div>
                                    ) : (
                                        <div
                                            className="sigContainer"
                                            style={{
                                                height: 200,
                                                borderRadius: 4,
                                                border: '1px solid rgba(0, 0, 0, 0.23)',
                                                boxSizing: 'border-box',
                                                overflow: 'hidden',
                                                position: 'relative'
                                            }}
                                        >
                                            <SignaturePad
                                                ref={signCanvas}
                                                canvasProps={{ className: 'sigPad' }}
                                                onEnd={() => {
                                                    GetTechnicianSign();
                                                }}
                                            />
                                            {state.vehicleInspectionStatusID === 4 ? (
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        right: 5,
                                                        bottom: 0,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-end',
                                                        background: 'rgba(255, 255, 255, 0.8)',
                                                        padding: '2px 4px',
                                                        borderRadius: 2
                                                    }}
                                                >
                                                    <Typography variant="body1">{state.vehicleInspectionSignedOffName}</Typography>
                                                    <Typography variant="button">
                                                        {moment(state.vehicleInspectionSignedOffDate).format('DD/MM/YYYY')}
                                                    </Typography>
                                                </div>
                                            ) : null}
                                        </div>
                                    )}
                                    <FormHelperText error>{state.errors?.vehicleInspectionSignedOffSignature}</FormHelperText>
                                </Grid>
                            </Grid>
                            <Grid container xs={12}>
                                <h5 className={classes.headings}>&nbsp;</h5>
                            </Grid>
                        </Grid>
                    )}
                </Paper>
            </Grid>
        </>
    );
};
